import type { FormState } from './types.ts';

// ═══ STATE ════════════════════════════════════════════════
// Ported verbatim from legacy/EMR Forms.html's "STATE" section: the shared
// mutable `state` object, uid()/_syncQSeq() sequential-ID generator,
// getQ()/getS() lookups, esc() HTML-escaper, and the section-target helpers
// isST()/sidFT() (a branch/skip "goto" value of the form "@sec_id" means
// "jump to section sec_id").

export function createFormState(): FormState {
  return {
    title: 'Untitled Form',
    description: '',
    coverMedia: null,
    logo: '',
    logos: { a: null, b: null },
    questions: [],
    sections: [],
    responses: [],
    captureLocation: true,
    clientName: '',
    projectName: '',
    deliveredDate: '',
  };
}

export const isST = (t: any): boolean => typeof t === 'string' && t.startsWith('@');
export const sidFT = (t: string): string => t.replace(/^@/, '');

export function esc(s: any): string {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string));
}

// Sequential alphanumeric ID generator: Q001, Q002, Q003 …
export function createUidGen() {
  let qSeq = 0;
  const uid = () => {
    qSeq++;
    return 'Q' + String(qSeq).padStart(3, '0');
  };
  // After any bulk load, advance counter past the highest existing ID
  const syncQSeq = (questions: FormState['questions']) => {
    questions.forEach((q) => {
      const m = String(q.id).match(/^Q(\d+)$/);
      if (m) { const n = parseInt(m[1], 10); if (n > qSeq) qSeq = n; }
    });
  };
  const reset = () => { qSeq = 0; };
  return { uid, syncQSeq, reset };
}

export function getQ(state: FormState, id: any): any {
  return state.questions.find((q) => String(q.id) === String(id));
}
export function getS(state: FormState, id: any): any {
  return state.sections.find((s) => String(s.id) === String(id));
}
